(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('.mry-header-search').forEach((root) => {
      if (root.hasAttribute('data-mry-header-search-controls-ready')) return;

      const details = root.querySelector('details');
      const summary = root.querySelector('summary');
      const form = root.querySelector('[data-mry-predictive-search]');
      const input = root.querySelector('[data-mry-predictive-input]');
      const panel = root.querySelector('[data-mry-predictive-panel]');
      const resultsScroller = root.querySelector('[data-mry-predictive-list]');
      const drawer = root.querySelector('[data-mry-search-drawer]');
      const popular = root.querySelector('[data-mry-popular-searches]');
      const resultCount = root.querySelector('[data-mry-predictive-count]');
      const resetButton = root.querySelector('[data-mry-predictive-reset]');
      const submitButton = root.querySelector('[data-mry-search-submit]');
      const overlay = root.querySelector('.modal-overlay');
      const closeButton = root.querySelector('.search-modal__close-button');
      const pageHeader = root.closest('.section-header');
      if (
        !details
        || !summary
        || !form
        || !input
        || !panel
        || !resultsScroller
        || !drawer
        || !popular
        || !resultCount
        || !resetButton
        || !overlay
        || !closeButton
      ) return;

      root.setAttribute('data-mry-header-search-controls-ready', 'true');
      let suppressEscapeKeyup = false;
      let openScrollPosition = 0;
      let bodyStyles = null;
      let closeTimer = null;
      let closeEnd = null;
      let nativeClose = null;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileSheet = window.matchMedia('(max-width: 749px)');
      const setSearchViewport = () => {
        const viewport = window.visualViewport;
        const viewportHeight = viewport?.height || window.innerHeight;
        const viewportTop = viewport?.offsetTop || 0;
        root.style.setProperty('--mry-search-viewport-height', `${viewportHeight}px`);
        root.style.setProperty('--mry-search-viewport-top', `${viewportTop}px`);
      };
      const refreshSearchViewport = () => {
        if (!details.open) return;
        setSearchViewport();
        if (!panel.hidden) fitDrawerToResults('results');
      };
      const keyboardSettleTimers = new Set();
      const settleKeyboardViewport = () => {
        keyboardSettleTimers.forEach(window.clearTimeout);
        keyboardSettleTimers.clear();
        refreshSearchViewport();
        [100, 350, 700].forEach((delay) => {
          const timer = window.setTimeout(() => {
            keyboardSettleTimers.delete(timer);
            refreshSearchViewport();
          }, delay);
          keyboardSettleTimers.add(timer);
        });
      };
      input.addEventListener('blur', settleKeyboardViewport);
      input.addEventListener('focus', settleKeyboardViewport);
      window.addEventListener('scroll', refreshSearchViewport, { passive: true });
      window.visualViewport?.addEventListener('resize', refreshSearchViewport);
      window.visualViewport?.addEventListener('scroll', refreshSearchViewport);
      const cancelClose = () => {
        window.clearTimeout(closeTimer);
        if (closeEnd) drawer.removeEventListener('transitionend', closeEnd);
        closeEnd = null;
        closeTimer = null;
      };

      const setPopularVisibility = (state = 'idle') => {
        const showPopular = input.value.trim().length === 0 && state === 'idle';
        popular.hidden = !showPopular;
        root.classList.toggle('is-searching', state !== 'idle');
        root.classList.toggle('has-results', state === 'results');
      };

      const fitDrawerToResults = (state) => {
        if (state === 'idle') {
          root.style.removeProperty('--mry-search-results-height');
          return;
        }
        requestAnimationFrame(() => {
          if (panel.hidden || !details.open) return;
          const drawerRect = drawer.getBoundingClientRect();
          const panelRect = panel.getBoundingClientRect();
          const maxPanelHeight = Number.parseFloat(getComputedStyle(panel).maxHeight) || panel.scrollHeight;
          const visiblePanelHeight = Math.min(panel.scrollHeight, maxPanelHeight);
          const compactHeight = Math.ceil(panelRect.top - drawerRect.top + visiblePanelHeight + 20);
          root.style.setProperty('--mry-search-results-height', `${Math.min(500, compactHeight)}px`);
        });
      };

      const lockPage = () => {
        if (bodyStyles) return;
        openScrollPosition = window.scrollY;
        const headerViewportTop = pageHeader?.getBoundingClientRect().top;
        bodyStyles = {
          overflow: document.body.style.overflow,
          overscrollBehavior: document.body.style.overscrollBehavior,
          position: document.body.style.position,
          top: document.body.style.top,
          right: document.body.style.right,
          left: document.body.style.left,
          width: document.body.style.width,
        };
        document.documentElement.classList.add('mry-header-search-open');
        document.body.style.overflow = 'hidden';
        document.body.style.overscrollBehavior = 'none';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${openScrollPosition}px`;
        document.body.style.right = '0';
        document.body.style.left = '0';
        document.body.style.width = '100%';
        // Fixed body locking disables sticky positioning. Keep the header in flow
        // and compensate its visual offset in this same task, before any paint.
        if (pageHeader && Number.isFinite(headerViewportTop)) {
          const frozenHeaderOffset = headerViewportTop - pageHeader.getBoundingClientRect().top;
          pageHeader.style.setProperty('--mry-search-frozen-header-top', `${frozenHeaderOffset}px`);
        }
      };

      const unlockPage = () => {
        if (!bodyStyles) return;
        const restoreScrollPosition = openScrollPosition;
        const previousScrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        Object.entries(bodyStyles).forEach(([property, value]) => {
          document.body.style[property] = value;
        });
        bodyStyles = null;
        window.scrollTo(0, restoreScrollPosition);
        document.documentElement.classList.remove('mry-header-search-open');
        pageHeader?.style.removeProperty('--mry-search-frozen-header-top');
        document.documentElement.style.scrollBehavior = previousScrollBehavior;
      };

      const openSearch = () => {
        cancelClose();
        document.querySelectorAll('[data-mry-mobile-nav][open]').forEach(navigation => {
          navigation._mryCloseImmediately?.();
        });
        document.querySelectorAll('.mry-header-desktop-nav__shop').forEach(navigation => {
          navigation.dispatchEvent(new Event('fxl:close'));
        });
        setSearchViewport();
        lockPage();
        root._mrySearchReturnFocus ||= summary;
        const wasOpen = details.open;
        details.open = true;
        drawer.inert = false;
        if (!wasOpen) drawer.getBoundingClientRect();
        root.classList.remove('is-closing');
        root.classList.add('is-open');
        summary.setAttribute('aria-expanded', 'true');
        // Focus while handling the tap, after the input becomes visible, so mobile keyboards open once.
        if (typeof trapFocus === 'function') trapFocus(drawer, input);
        input.focus({ preventScroll: true });
      };

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!details.open || root.classList.contains('is-closing')) {
          root._mrySearchReturnFocus ||= summary;
          openSearch();
        }
        else closeSearchSmoothly();
      }, true);

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || !details.open || root.classList.contains('is-closing')) return;
        // Search suggestions change the available controls after the drawer opens.
        const controls = Array.from(drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'))
          .filter(control => control.tabIndex >= 0 && !control.disabled && !control.closest('[hidden], [inert]')
            && control.getClientRects().length > 0 && getComputedStyle(control).visibility !== 'hidden');
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!controls.length) { drawer.focus(); return; }
        const currentIndex = controls.indexOf(document.activeElement);
        const nextIndex = currentIndex < 0
          ? (event.shiftKey ? controls.length - 1 : 0)
          : (currentIndex + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
        controls[nextIndex].focus();
      }, true);

      const updateResetButton = () => {
        resetButton.classList.toggle('hidden', input.value.length === 0);
        submitButton?.classList.toggle('hidden', input.value.length !== 0);
        if (input.value.trim().length === 0) {
          setPopularVisibility('idle');
        } else {
          setPopularVisibility('loading');
        }
      };

      const syncHeroQueries = (value) => {
        document.querySelectorAll('.mryp-search[data-mry-predictive-search] [data-mry-predictive-input]')
          .forEach((heroInput) => {
            if (heroInput.value !== value) heroInput.value = value;
          });
      };

      const resetSearchSession = () => {
        if (input.value !== '') {
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
        } else {
          updateResetButton();
          setPopularVisibility('idle');
        }
        syncHeroQueries('');
      };

      const closeSearchSmoothly = (restoreFocus = true) => {
        if (!details.open || root.classList.contains('is-closing')) return;

        cancelClose();
        root.classList.add('is-closing');
        root.classList.remove('is-open');
        const returnFocusTarget = root._mrySearchReturnFocus || summary;
        root._mrySearchReturnFocus = null;
        const finishClose = () => {
          if (!root.classList.contains('is-closing')) return;
          cancelClose();
          if (nativeClose) {
            nativeClose(false);
          } else {
            if (typeof removeTrapFocus === 'function') removeTrapFocus();
            details.open = false;
            document.body.classList.remove('overflow-hidden');
          }
          root.classList.remove('is-closing');
          drawer.inert = true;
          resetSearchSession();
          unlockPage();
          summary.setAttribute('aria-expanded', 'false');
          if (restoreFocus && typeof returnFocusTarget.focus === 'function') {
            returnFocusTarget.focus({ preventScroll: true });
          }
        };
        closeEnd = (event) => {
          if (event.target === drawer && event.propertyName === 'transform') finishClose();
        };
        drawer.addEventListener('transitionend', closeEnd);
        closeTimer = window.setTimeout(finishClose, reducedMotion.matches ? 0 : 240);
      };

      root._mryCloseImmediately = () => {
        cancelClose();
        if (nativeClose) nativeClose(false);
        else {
          if (typeof removeTrapFocus === 'function') removeTrapFocus();
          details.open = false;
          document.body.classList.remove('overflow-hidden');
        }
        root.classList.remove('is-open', 'is-closing');
        root._mrySearchReturnFocus = null;
        drawer.inert = true;
        resetSearchSession();
        unlockPage();
        summary.setAttribute('aria-expanded', 'false');
      };

      details.addEventListener('toggle', () => {
        if (details.open) {
          if (!root.classList.contains('is-open') && !root.classList.contains('is-closing')) openSearch();
        } else {
          cancelClose();
          root.classList.remove('is-open', 'is-closing');
          resetSearchSession();
          unlockPage();
          drawer.inert = true;
          summary.setAttribute('aria-expanded', 'false');
        }
      });

      customElements.whenDefined('details-modal').then(() => {
        nativeClose = root.close.bind(root);
        root.open = openSearch;
        root.close = closeSearchSmoothly;
      });
      drawer.inert = !details.open;
      summary.setAttribute('aria-expanded', String(details.open));

      // Keep the keyboard from resizing the panel before the close tap is handled.
      [closeButton, overlay].forEach(control => control.addEventListener('pointerdown', event => {
        if (event.isPrimary && event.button === 0) event.preventDefault();
      }));
      let resultsTouch = null;
      resultsScroller.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1 || resultsScroller.scrollHeight <= resultsScroller.clientHeight) {
          resultsTouch = null;
          return;
        }
        resultsTouch = {
          startY: event.touches[0].clientY,
          startScrollTop: resultsScroller.scrollTop,
          moved: false,
        };
      }, { passive: true });
      resultsScroller.addEventListener('touchmove', (event) => {
        if (!resultsTouch || event.touches.length !== 1) return;
        const deltaY = resultsTouch.startY - event.touches[0].clientY;
        if (!resultsTouch.moved && Math.abs(deltaY) < 4) return;
        resultsTouch.moved = true;
        resultsScroller.scrollTop = resultsTouch.startScrollTop + deltaY;
        event.preventDefault();
      }, { passive: false });
      ['touchend', 'touchcancel'].forEach((eventName) => {
        resultsScroller.addEventListener(eventName, () => { resultsTouch = null; }, { passive: true });
      });
      let resultsPointer = null;
      resultsScroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' || resultsScroller.scrollHeight <= resultsScroller.clientHeight) return;
        resultsPointer = {
          pointerId: event.pointerId,
          startY: event.clientY,
          startScrollTop: resultsScroller.scrollTop,
          moved: false,
        };
      });
      resultsScroller.addEventListener('pointermove', (event) => {
        if (!resultsPointer || resultsPointer.pointerId !== event.pointerId) return;
        const deltaY = resultsPointer.startY - event.clientY;
        if (!resultsPointer.moved && Math.abs(deltaY) < 4) return;
        resultsPointer.moved = true;
        if (!resultsScroller.hasPointerCapture?.(event.pointerId)) {
          resultsScroller.setPointerCapture?.(event.pointerId);
        }
        resultsScroller.scrollTop = resultsPointer.startScrollTop + deltaY;
        event.preventDefault();
      }, { passive: false });
      ['pointerup', 'pointercancel'].forEach((eventName) => {
        resultsScroller.addEventListener(eventName, (event) => {
          if (resultsPointer?.pointerId === event.pointerId) resultsPointer = null;
        });
      });
      closeButton.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          closeSearchSmoothly();
        },
        true
      );

      overlay.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          closeSearchSmoothly();
        },
        true
      );

      root.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape' || !details.open || !panel.hidden) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          closeSearchSmoothly();
        },
        true
      );

      root.addEventListener('mry:predictive-state', (event) => {
        const state = event.detail?.state || 'idle';
        const count = Number(event.detail?.count) || 0;
        resultCount.textContent = state === 'results'
          ? `${count} match${count === 1 ? '' : 'es'}`
          : '';
        setPopularVisibility(state);
        fitDrawerToResults(state);
      });

      input.addEventListener('input', () => {
        updateResetButton();
        syncHeroQueries(input.value);
      });
      form.addEventListener('reset', (event) => {
        event.preventDefault();
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus({ preventScroll: true });
      });

      input.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'Escape' && !panel.hidden) {
            suppressEscapeKeyup = true;
          }
        },
        true
      );

      input.addEventListener('keyup', (event) => {
        if (event.key === 'Escape' && (suppressEscapeKeyup || root.classList.contains('is-closing'))) {
          event.stopPropagation();
          suppressEscapeKeyup = false;
        }
      });

      window.addEventListener('pagehide', root._mryCloseImmediately);
      let viewportFrame = null;
      const scheduleViewport = () => {
        if (!details.open || viewportFrame !== null) return;
        viewportFrame = requestAnimationFrame(() => {
          viewportFrame = null;
          if (details.open && !root.classList.contains('is-closing')) setSearchViewport();
        });
      };
      window.addEventListener('resize', scheduleViewport);
      window.visualViewport?.addEventListener('resize', scheduleViewport);
      window.visualViewport?.addEventListener('scroll', scheduleViewport);
      if (new URLSearchParams(window.location.search).get('search_debug') === '20261009') {
        const debug = document.createElement('pre');
        debug.setAttribute('data-fxl-search-debug', '20261009');
        debug.setAttribute('aria-hidden', 'true');
        debug.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:2147483647;pointer-events:none;background:#111;color:#D6E65C;padding:8px;font:11px/1.4 monospace;white-space:pre-wrap;margin:0;';
        document.body.append(debug);
        let lastEvent = 'ready';
        let lastGesture = 'none';
        const readDebug = () => {
          const viewport = window.visualViewport;
          const button = root.querySelector('[data-mry-predictive-all]');
          const rect = (element) => {
            const value = element?.getBoundingClientRect();
            return value ? `${Math.round(value.top)}..${Math.round(value.bottom)}` : '-';
          };
          debug.textContent = `FXL SEARCH 20261009 | ${lastEvent} | ${details.open ? 'OPEN' : 'CLOSED'}\n`
            + `VIEW ${Math.round(viewport?.height || innerHeight)} top ${Math.round(viewport?.offsetTop || 0)} | DRAWER ${rect(drawer)}\n`
            + `PANEL ${rect(panel)} | BUTTON ${rect(button)}\n`
            + `LIST ${Math.round(resultsScroller.scrollTop)}/${Math.max(0, resultsScroller.scrollHeight - resultsScroller.clientHeight)} | ${lastGesture}`;
        };
        ['focus', 'blur'].forEach((name) => input.addEventListener(name, () => { lastEvent = name; readDebug(); }));
        ['touchstart', 'touchmove', 'pointerdown', 'pointermove'].forEach((name) => {
          resultsScroller.addEventListener(name, () => { lastGesture = name; readDebug(); }, { passive: true });
        });
        const debugTimer = window.setInterval(readDebug, 250);
        window.addEventListener('pagehide', () => window.clearInterval(debugTimer), { once: true });
        readDebug();
      }
      updateResetButton();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
